// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "./static/css/" + "index" + "." + __webpack_require__.h() + ".css";
};